import { useSelector } from 'react-redux'

const TagManager = {
  dataLayer: ({ dataLayer, dataLayerName = 'dataLayer' }) => {
    if (typeof window === 'undefined') return
    window[dataLayerName] = window[dataLayerName] || []
    window[dataLayerName].push(dataLayer)
  }
}

const useTracking = () => {
  const { campaignId } = useSelector((state) => state.campaignReducers.campaign)

  const track = ({ event, parameter, value }) => {
    const objData = {
      ...(value ? { valor: Array.isArray(value) ? value.join(',') : value } : {}),
      ...(parameter ? { parametro: parameter } : {}),
      ...(campaignId ? { campanha: campaignId } : {})
    }

    TagManager.dataLayer({
      dataLayer: {
        event: `e_${event}`,
        ...objData
      }
    })

    if (typeof window?.Native?.genericEvent === 'function') {
      window.Native.genericEvent(`e_${event}`, objData)
    }
  }

  return track
}

export default useTracking
